import { graphql, useStaticQuery } from 'gatsby';
import { DISABLE_INDEXING } from 'gatsby-env-variables';
import BankGuarantee from '../components/home/BankGuarantee';
import { BeforeYouApply } from '../components/home/BeforeYouApply';
import { Disclaimer } from '../components/home/Disclaimer';
import FAQHome from '../components/home/FAQHome';
import FastFairFussFree from '../components/home/FastFairFussFree';
import FeatureCards from '../components/home/FeatureCards';
import ImageAndContent from '../components/home/ImageAndContent';
import TestimonialSlider from '../components/home/TestimonialSlider';
import { IndustryRecognised } from '../components/beneficiary/IndustryRecognised';
import BeneficiaryCarousel from '../components/common/BeneficiaryCarousel/BeneficiaryCarousel';
import Layout from '../components/layout';
import Seo from '../components/layouts/seo';

function IndexPage() {
    const { homeBanner } = useStaticQuery(graphql`
        {
            homeBanner: contentfulSiteImages(name: { eq: "HomeHeroImage" }) {
                name
                imageFile {
                    publicUrl
                    localFile {
                        childImageSharp {
                            fluid(maxWidth: 800, quality: 80, srcSetBreakpoints: [400, 600, 800, 960, 1280, 1920]) {
                                ...GatsbyImageSharpFluid
                                ...GatsbyImageSharpFluidLimitPresentationSize
                                src
                            }
                        }
                    }
                }
            }
        }
    `);

    const imageOutput = homeBanner.imageFile.localFile?.childImageSharp.fluid.src;

    return (
        <Layout pageInfo={{ pageName: 'index' }}>
            {/*<link rel='modulepreload' href='/about.js' />*/}
            {/*<link rel='modulepreload' href='/bank-guarantee.js' />*/}
            {/*<link rel='modulepreload' href='/careers.js' />*/}
            {/*<link rel='modulepreload' href='/contact.js' />*/}
            {/*<link rel='modulepreload' href='/landlords.js' />*/}
            {/*<link rel='modulepreload' href='/partners.js' />*/}
            <Seo
                title='Avenue Bank | Bank guarantees in less than 24 hours'
                keywords={[
                    'Avenue Bank',
                    'Avenue',
                    'A new way for Australian businesses',
                    'Avenue Bank Guarantee',
                    'Bank Guarantee',
                    'Bank Guarantee Australia',
                    'Bank Guarantee Sydney',
                    'Bank Guarantee Melbourne',
                    'Bank Guarantee Brisbane',
                    'Bank Guarantee Perth',
                    'Bank Guarantee Adelaide',
                    'Bank Guarantee Darwin',
                    'Bank Guarantee Hobart',
                    'Bank Guarantee Canberra',
                    'Bank Guarantee Parramatta',
                    'Bank Guarantee Gold Coast',
                    'Bank Guarantee Newcastle',
                    'Bank Guarantee Wollongong',
                    'Bank Guarantee Sunshine Coast',
                    'Bank Guarantee Geelong',
                    'Bank Guarantee Townsville',
                    'Bank Guarantee Cairns',
                    'Bank Guarantee Toowoomba',
                    'Bank Guarantee Ballarat',
                    'Bank Guarantee Bendigo',
                    'Bank Guarantee Albury Wodonga',
                    'Fast Bank Guarantee',
                    'Bank Guarantees in less than 24 hours',
                ]}
                description='Bank guarantees reinvented. Avenue Bank has made the bank guarantee stress free for your business. Fully digital, you get your guarantee in 24 hours.'
                imagePath={imageOutput}
                pageUrl='/'
                loading='lazy'
                noindex={DISABLE_INDEXING}
            />
            <BankGuarantee />
            <FeatureCards />
            <TestimonialSlider />
            <BeneficiaryCarousel />
            <FastFairFussFree />
            <IndustryRecognised className='my-16' />
            <BeforeYouApply />
            <FAQHome />
            <ImageAndContent />
            <Disclaimer />
        </Layout>
    );
}

export default IndexPage;
